import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CoreModule } from '@core/core.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';

import { AppRouterModule } from '@app/router.module';

import { SettingsRulesRulesFormHelpersModule } from './helpers/rules-form-helpers.module';
import { SettingsRulesRulesFormConditionsModule } from './conditions/conditions.module';

import { SettingsRulesRuleFormMainComponent } from './main/main.component';
import { SettingsRulesRulesFormActionsModule } from './actions/actions.module';
// import { SettingsRulesRuleFormConditionsItemComponent }./conditions/conditions-main/conditions-main.componentonent';
// import { SettingsRulesRuleFormActionsComponent } from './actions/actions.component';
// import { SettingsRulesRuleFormActionsItemComponent } from './actions-item/actions-item.component';
// import { SettingsRulesRuleFormActionsVariableItemComponent } from './actions-variable-item/actions-variable-item.component';

@NgModule({
    imports: [
        CommonModule,
        AppRouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        HelpersModule,
        SettingsRulesRulesFormHelpersModule,
        SettingsRulesRulesFormConditionsModule,
        SettingsRulesRulesFormActionsModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        SettingsRulesRuleFormMainComponent,
        // SettingsRulesRuleFormConditionsItemComponent,
        // SettingsRulesRuleFormActionsComponent,
        // SettingsRulesRuleFormActionsItemComponent,
        // SettingsRulesRuleFormActionsVariableItemComponent,
    ],
    exports: [
        SettingsRulesRuleFormMainComponent,
        // SettingsRulesRuleFormConditionsItemComponent,
        // SettingsRulesRuleFormActionsComponent,
        // SettingsRulesRuleFormActionsItemComponent,
        // SettingsRulesRuleFormActionsVariableItemComponent,
    ],

})
export class SettingsRulesRulesFormModule { }
